<template>
  <div class="colorpicker">
    <div class="spaced-row ">
      <mad-input class="input" :value="value" type="text" @focus="onFocus" @input="onInput" />
      <div class="color-check" :style="{ backgroundColor: value }"></div>
    </div>

    <div v-if="showColorpicker" class="colorpicker-menu">
      <color-picker :value="value" @input="selectColor" />
      <mad-button color="brown" @click="showColorpicker=false">
        <mad-icon mdi="check" />
        Done
      </mad-button>
    </div>
  </div>
</template>

<script>
import ColorPicker from 'vue-color-picker-wheel'

export default {
  components: {
    ColorPicker,
  },

  props: {
    value: { type: String, default: null },
  },

  data: () => ({
    showColorpicker: false,
  }),

  mounted() {
    this.onClick = (event) => {
      if (!this.$el.contains(event.target)) {
        this.showColorpicker = false
      }
    }
    window.addEventListener('click', this.onClick)
  },

  beforeDestroy() {
    window.removeEventListener('click', this.onClick)
  },

  methods: {
    onFocus() {
      this.showColorpicker = true
    },

    onInput(value) {
      this.$emit('input', value.toUpperCase())
    },

    selectColor(value) {
      this.$emit('input', value.toUpperCase())
    },
  },
}
</script>

<style lang="scss">
.colorpicker {
  position: relative;
}

.color-check {
  width: 35px;
  height: 35px;
  border: solid 2px #e3e3e3;
  border-radius: 100%;
}

.input {
  width: 100px;
}

.colorpicker-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  background: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  width: 330px;
  padding: 1rem;
  border-radius: 10px;
}
</style>
